module.exports = __webpack_public_path__ + "static/media/AsYouWalkonByBookCover.d92184a1.jpg";